/**
 * Котометеоры: лапки и мордочки падают сверху, когда кто-то мурлычет.
 */

import { useEffect, useMemo } from "react";

import type { ChatFx } from "@koshkodrop/shared";

interface Props {
  kind: ChatFx | null;
  nonce: number | null;
  onDone: () => void;
}

const PAWS = ["🐾", "🐾", "✨"];
const PURR = ["🐾", "😺", "😻", "😽", "✨", "💛"];

export function PawRain({ kind, nonce, onDone }: Props) {
  const flakes = useMemo(() => {
    if (!kind || nonce === null) return [];
    const glyphs = kind === "purr" ? PURR : PAWS;
    const count = kind === "purr" ? 22 : 14;
    return Array.from({ length: count }, (_, index) => ({
      id: `${nonce}-${index}`,
      glyph: glyphs[index % glyphs.length]!,
      left: 4 + ((index * 37) % 92),
      delay: (index % 8) * 0.08,
      duration: 1.6 + (index % 5) * 0.18,
      size: kind === "purr" ? 18 + (index % 4) * 4 : 14 + (index % 3) * 3,
    }));
  }, [kind, nonce]);

  useEffect(() => {
    if (!kind) return;
    const timer = window.setTimeout(onDone, 2400);
    return () => window.clearTimeout(timer);
  }, [kind, nonce, onDone]);

  if (!kind) return null;

  return (
    <div className="pointer-events-none absolute inset-0 z-30 overflow-hidden">
      {flakes.map((flake) => (
        <span
          key={flake.id}
          className="absolute top-0 animate-paw-fall"
          style={{
            left: `${flake.left}%`,
            animationDelay: `${flake.delay}s`,
            animationDuration: `${flake.duration}s`,
            fontSize: flake.size,
          }}
        >
          {flake.glyph}
        </span>
      ))}
    </div>
  );
}
